import React from 'react';

interface HedgehogLogoProps {
  size?: number;
  showWordmark?: boolean;
  className?: string;
}

export const HedgehogLogo: React.FC<HedgehogLogoProps> = ({
  size = 28,
  showWordmark = true,
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-2.5 select-none ${className}`}>
      {/* SVG Hedgehog Mascot Icon (Grayscale & Monochrome) */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0 text-cf-textPrimary"
      >
        {/* Back and Spikes */}
        <path
          d="M 6 22 L 4 14 L 10 17 L 9 8 L 16 14 L 17 4 L 22 13 L 26 8 L 25 18 Z"
          className="fill-cf-textPrimary"
        />
        {/* Aerodynamic Body Contour */}
        <path
          d="M 6 22 C 6 26 12 28 19 28 C 26 28 29 25 30 22 C 30 20 28 18 25 18 L 10 18 C 8 18 6 20 6 22 Z"
          className="fill-cf-surfaceActive stroke-cf-border"
          strokeWidth="1.5"
        />
        {/* Snout and Face */}
        <path
          d="M 25 18 L 31 21 C 31.5 21.3 31.5 22 31 22.3 L 27 24 Z"
          className="fill-cf-textSecondary"
        />
        {/* Nose */}
        <circle cx="31" cy="21.5" r="1.2" className="fill-cf-textPrimary" />

        {/* Watchful eye */}
        <circle cx="26" cy="19.5" r="1.2" className="fill-cf-textPrimary" />
        <circle cx="26.3" cy="19.3" r="0.6" className="fill-cf-bg" />

        {/* Glowing Data Nodes on Spike Tips */}
        <circle cx="4" cy="14" r="1.2" className="fill-cf-textSecondary" />
        <circle cx="9" cy="8" r="1.2" className="fill-cf-textSecondary" />
        <circle cx="17" cy="4" r="1.4" className="fill-cf-textPrimary" />
        <circle cx="26" cy="8" r="1.2" className="fill-cf-textSecondary" />

        {/* Paws */}
        <rect x="11" y="27.5" width="3" height="2" rx="1" className="fill-cf-textSecondary" />
        <rect x="21" y="27.5" width="3" height="2" rx="1" className="fill-cf-textSecondary" />
      </svg>

      {/* Brand Wordmark */}
      {showWordmark && (
        <span className="font-bold text-sm tracking-wider text-cf-textPrimary font-sans">
          ERICIUS
        </span>
      )}
    </div>
  );
};
